import UserToken from '@admin/tokens/user'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Preview extends React.Component {

  static contextTypes = {
    admin: PropTypes.object,
    flash: PropTypes.object
  }

  static propTypes = {
    config: PropTypes.object,
    email: PropTypes.object,
    onBack: PropTypes.func
  }

  formRef = React.createRef()

  state = {
    config: {}
  }

  _handleBack = this._handleBack.bind(this)
  _handleChange = this._handleChange.bind(this)
  _handleSend = this._handleSend.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { admin } = this.context
    const { config, email } = this.props
    return {
      ref: this.formRef,
      title: 't(Send Preview)',
      method: 'POST',
      action: '/api/admin/automation/emails/preview',
      onCancel: this._handleBack,
      onChange: this._handleChange,
      onSuccess: this._handleSuccess,
      cancelSvg: 'chevron_left',
      saveText: null,
      buttons: [
        { label: 'Send', color: 'blue', handler: this._handleSend }
      ],
      sections: [
        {
          fields: [
            { type: 'hidden', name: 'sender_id', defaultValue: email.sender.id },
            { type: 'hidden', name: 'subject', defaultValue: email.subject },
            { type: 'hidden', name: 'preview_text', defaultValue: email.preview_text },
            { type: 'hidden', name: 'config', defaultValue: config },
            { type: 'segment', fields: [
              { name: 'strategy', type: 'radiogroup', options: [
                { value: 'me', text: `Send to ${admin.user.email}` },
                { value: 'user', text: 't(Choose a specific user)' },
                { value: 'email', text: 't(Enter an email address)' }
              ], defaultValue: 'me' },
              ...this._getStrategy()
            ] }
          ]
        }
      ]
    }
  }

  _getStrategy() {
    const { config } = this.state
    if(config.strategy === 'email') {
      return [
        { label: 't(First Name)', type: 'textfield', name: 'first_name', required: true },
        { label: 't(Last Name)', type: 'textfield', name: 'last_name', required: true },
        { label: 't(Email)', type: 'emailfield', name: 'email', required: true }
      ]
    } else if(config.strategy === 'user') {
      return [{ name: 'user_id', type: 'lookup', required: true, prompt: 't(Choose a User)', endpoint: '/api/admin/users', filter: { is_active: { $eq: true } }, valueKey: 'id', textKey: 'full_name', format: UserToken }]
    }
    return []
  }

  _handleBack() {
    this.props.onBack()
  }

  _handleChange(config) {
    this.setState({ config })
  }

  _handleSend() {
    this.formRef.current.submit()
  }

  _handleSuccess() {
    this.context.flash.set('success', 'Successfully send preview email')
    this.props.onBack()
  }

}

export default Preview
